import React, { useEffect, useRef, useState } from 'react';
import Slider from "react-slick";
import ReactPlayer from "react-player";
import { CiPlay1, CiPause1 } from 'react-icons/ci';
import { Helmet } from 'react-helmet';
import video1 from '../images/video/video_1.mp4';
import video2 from '../images/video/video_2.mp4';
import video3 from '../images/video/video_3.mp4';
import video4 from '../images/video/video_4.mp4';

import iconorange from '../images/icon_orange.svg';
import AnimatedText10 from './AnimatedText10';
const VideoSlider = () => {
    const settings = {
        dots: false,
        speed: 500,
        infinite: false,
        slidesToShow: 4,
        slidesToScroll: 4,
        initialSlide: 0,
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    centerMode: true,
                    centerPadding: "60px",
                    infinite: true,
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 600,
                settings: {
                    centerMode: true,
                    centerPadding: "60px",
                    slidesToShow: 1.5,
                    slidesToScroll: 1,
                    initialSlide: 1
                }
            },
            {
                breakpoint: 480,
                settings: {
                    centerMode: true,
                    centerPadding: "60px",
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    initialSlide: 1,
                }
            }
        ]
    };
    const sliderRef = useRef(null);
    const videos = [video2, video1, video3, video4];
    const [playingIndex, setPlayingIndex] = useState(null);

    const handlePlay = (index) => {
        setPlayingIndex(index);
        // Play the selected video
    };

    const handlePause = () => {
        setPlayingIndex(null); // Pause all videos
    };

    useEffect(() => {
        const handleResize = () => {
            const screenWidth = window.innerWidth;
            if (screenWidth <= 768 && sliderRef.current) {
                sliderRef.current.slickGoTo(1);
            }
        };
        handleResize();
    }, []);


    return (

        <section id="client">
            <div className='container-xxl client-container'>

                <div className='text-box' data-aos="fade-up">
                    <img id="clientimg" className='icon_orange' src={iconorange} alt='icon-orange' />
                    <p>Video reviews</p>
                </div>

                <AnimatedText10 />

                <div className='client-main'>
                    <Helmet>
                        <link rel="preload" href={video1} as="video" type="video/mp4" />
                        <link rel="preload" href={video2} as="video" type="video/mp4" />
                        <link rel="preload" href={video3} as="video" type="video/mp4" />
                        <link rel="preload" href={video4} as="video" type="video/mp4" />
                    </Helmet>
                    <div className="slider-container">
                        <Slider ref={sliderRef} {...settings}>
                            {videos.map((videoSrc, index) => (
                                <div key={index}>
                                    <div className='slide-box'>
                                        {playingIndex !== index ? (
                                            <button
                                                className='btn-video'
                                                onClick={() => handlePlay(index)}
                                            >
                                                <CiPlay1 />
                                            </button>
                                        ) : (
                                            <button
                                                className='btn-video'
                                                onClick={handlePause}
                                            >
                                                <CiPause1 />
                                            </button>
                                        )}
                                        <div className='video-container'>
                                            <ReactPlayer
                                                className='video-box'
                                                url={videoSrc}
                                                playing={playingIndex === index}
                                                // muted={true}
                                                playsinline
                                                controls={false}
                                                width="100%"
                                                height="100%"
                                                onClick={() => handlePause()}
                                            />
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </Slider>
                    </div>
                </div>

            </div>
        </section>

    );
};

export default VideoSlider;
